/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Recipient_PosthogInputs */

const da_privacy_recipient_posthog = /** @type {(inputs: Privacy_Recipient_PosthogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PostHog, som registrerer brugsstatistik og fejl og indsamler svar på feedback. Vi bruger PostHogs hosting i EU.`)
};

/** @type {(inputs: Privacy_Recipient_PosthogInputs) => LocalizedString} */
const en_privacy_recipient_posthog = da_privacy_recipient_posthog;

/**

* @param {Privacy_Recipient_PosthogInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const privacy_recipient_posthog = /** @type {((inputs?: Privacy_Recipient_PosthogInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Recipient_PosthogInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_privacy_recipient_posthog(inputs)
	return /** @type {LocalizedString} */ ("PostHog, som registrerer brugsstatistik og fejl og indsamler svar på feedback. Vi bruger PostHogs hosting i EU.")
});